import { useEffect } from "react";
import AboutBuiltFor from "../../components/about/AboutBuiltFor";
import AboutCTA from "../../components/about/AboutCTA";
import AboutFeatures from "../../components/about/AboutFeatures";
import AboutHero from "../../components/about/AboutHero";
import AboutReason from "../../components/about/AboutReason";

const About = () => {
  useEffect(() => {
    // Title
    document.title = "About VisualLab – Interactive Visual Learning Platform";

    // Meta description
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content =
      "Learn about VisualLab, a platform built to explain complex concepts through interactive animations and visual storytelling.";

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${window.location.origin}/about`;
  }, []);

  useEffect(() => {
    // Structured data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "About VisualLab",
      description:
        "VisualLab is an interactive visual learning platform designed to make complex concepts intuitive and engaging.",
      url: `${window.location.origin}/about`,
    });

    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <>
      <AboutHero />
      <AboutReason />
      <AboutFeatures />
      <AboutBuiltFor />
      <AboutCTA />
    </>
  );
};

export default About;
